// extracted by mini-css-extract-plugin
export default {"content":"OffersTokenTabContent-module__content--qUX5B","offersList":"OffersTokenTabContent-module__offersList--idedU"};